import React from "react";
import { Text } from "src/components/ui/Text";
import CheckBoxListsScope1 from "./CheckBoxListsScope1";
import CheckBoxListsScope2 from "./CheckBoxListsScope2";
import CheckBoxListsScope3 from "./CheckBoxListsScope3";

const CheckBoxListsForm = (props) => {
  const { control, disabled } = props;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-end gap-2">
        <Text variant="bold-14">Details of Scopes of the Company</Text>
        <Text variant="normal-10">
          Please select the details of scopes of the company
        </Text>
      </div>

      <div className="flex flex-col gap-6">
        {/* lists of scope 1 */}
        <CheckBoxListsScope1 control={control} disabled={disabled} />

        {/* lists of scope 2 */}
        <CheckBoxListsScope2 control={control} disabled={disabled} />

        {/* lists of scope 3 */}
        <CheckBoxListsScope3 control={control} disabled={disabled} />
      </div>
    </div>
  );
};

export default CheckBoxListsForm;
